import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { healthAPI } from '../services/api';
import Maintenance from '../pages/Maintenance';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const [backendAvailable, setBackendAvailable] = useState(true);
  const [hasCheckedBackend, setHasCheckedBackend] = useState(false);

  useEffect(() => {
    // Only check backend connectivity once per user session
    if (!user || hasCheckedBackend) return;

    let isMounted = true;

    const checkBackendConnection = async () => {
      try {
        // Try a simple health check to verify backend is reachable
        await healthAPI.check();
        if (!isMounted) return;
        setBackendAvailable(true);
      } catch (error) {
        if (!isMounted) return;
        // Check if it's a network error (backend not reachable)
        if (
          error.code === 'ERR_NETWORK' ||
          error.message === 'Network Error' ||
          error.code === 'ECONNABORTED' ||
          (error.response && error.response.status >= 500)
        ) {
          setBackendAvailable(false);
        } else {
          // Other errors (like 401) mean backend is reachable
          setBackendAvailable(true);
        }
      } finally {
        if (isMounted) {
          setHasCheckedBackend(true);
        }
      }
    };

    checkBackendConnection();

    return () => {
      isMounted = false;
    };
  }, [user, hasCheckedBackend]);

  if (loading || (user && !hasCheckedBackend)) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  // If user is logged in but backend is not available, show maintenance page
  if (user && !backendAvailable) {
    return <Maintenance />;
  }

  return user ? children : <Navigate to="/login" />;
};

export default PrivateRoute;

